// Org-configured admin background color, persisted in localStorage so the
// next page load can paint the correct color before the API responds —
// avoids a brief flash of the default olive while the session/style is fetched.

const STORAGE_KEY = "quizBackgroundCss";

export function applyQuizBgColor(css) {
  if (typeof document === "undefined") return;
  if (css) {
    document.documentElement.style.setProperty("--quiz-bg-color", css);
  } else {
    document.documentElement.style.removeProperty("--quiz-bg-color");
  }
}

export function persistQuizBgColor(css) {
  if (typeof window === "undefined") return;
  try {
    if (css) {
      window.localStorage.setItem(STORAGE_KEY, css);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) { /* localStorage unavailable */ }
}

export function syncQuizBgColor(css) {
  applyQuizBgColor(css);
  persistQuizBgColor(css);
}

export function applyCachedQuizBgColorOnLoad() {
  if (typeof window === "undefined") return;
  try {
    const cached = window.localStorage.getItem(STORAGE_KEY);
    if (cached) {
      applyQuizBgColor(cached);
    }
  } catch (e) { /* ignore */ }
}
